import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import * as search from 'modules/search';

import {
    getEmptyNetSuiteParams,
    getEmptyQBooksParams,
    getEmptyStandaloneParams,
    getEmptyXeroParams,
    SearchParameters,
} from '../../data/SearchParameters';

export const isTemplateCreatable = (integrationCode: domain.IntegrationCode) => {
    return (
        integrationCode === domain.IntegrationCode.QBooksPo ||
        integrationCode === domain.IntegrationCode.XeroPo ||
        integrationCode === null
    );
};

export const getParamsAfterTemplateChange = (template: search.TemplateReference | null): Partial<SearchParameters> => {
    if (!template) {
        // reset all fields
        return {
            requestor: null,
            requestStatusV2: null,
            ...getEmptyStandaloneParams(),
            ...getEmptyXeroParams(),
            ...getEmptyQBooksParams(),
            ...getEmptyNetSuiteParams(),
        };
    }

    const integrationType = template && domain.getIntegrationTypeByCode(template.integrationCode);
    const canCreate = Boolean(template) && isTemplateCreatable(template.integrationCode);

    let result: Partial<SearchParameters>;

    switch (integrationType) {
        case domain.IntegrationType.None:
            // Changed to SA template => reset all other parameters, keep SA filters
            result = {
                ...getEmptyXeroParams(),
                ...getEmptyQBooksParams(),
                ...getEmptyNetSuiteParams(),
            };
            break;

        case domain.IntegrationType.Xero:
            result = {
                ...getEmptyStandaloneParams(),
                ...getEmptyXeroParams(),
                ...getEmptyQBooksParams(),
                ...getEmptyNetSuiteParams(),
            };
            delete result.xeroDocumentNumber;
            delete result.xeroDocumentReference;

            if (!canCreate) {
                result.requestor = null;
            }

            break;

        case domain.IntegrationType.QBooks:
            result = {
                ...getEmptyStandaloneParams(),
                ...getEmptyXeroParams(),
                ...getEmptyQBooksParams(),
                ...getEmptyNetSuiteParams(),
            };
            delete result.qbooksPoNumber;

            if (!canCreate) {
                result.requestor = null;
            }

            break;

        case domain.IntegrationType.NetSuite:
            result = {
                ...getEmptyStandaloneParams(),
                ...getEmptyXeroParams(),
                ...getEmptyQBooksParams(),
                ...getEmptyNetSuiteParams(),
            };

            if (!canCreate) {
                result.requestor = null;
            }

            break;

        case domain.IntegrationType.Dear:
            result = {
                ...getEmptyStandaloneParams(),
                ...getEmptyXeroParams(),
                ...getEmptyQBooksParams(),
                ...getEmptyNetSuiteParams(),
            };

            if (!canCreate) {
                result.requestor = null;
            }

            break;

        default:
            throw errorHelpers.assertNever(integrationType);
    }

    return result;
};
